<app-common-dialog-wrapper
  (onDialogClose)="onConfirmAndCloseDialog($event)"
  [confirmButton]="confirmButton"
  [headerIcon]="headerIcon"
  [headerText]="headerText"
  class="dialog-wrapper"
>
  <section class="account-container">
    <div class="account-container__tabs">
      <mds-tab
        (activeTabChange)="accountSettingSelectedTab($event.label)"
        [tabs]="accountTabs"
      ></mds-tab>
    </div>

    <div class="account-container__content">
      <perfect-scrollbar [scrollIndicators]="false">
        @if (selectedSection === accountSections.CHANGE_PASSWORD) {
          <div>
            <form (ngSubmit)="submit()" [formGroup]="form">
              <div class="form-group">
                <mat-label>
                  <span class="label-text">Old Password</span>
                  <div class="required-info">
                    <span class="required">*</span>
                    <mat-icon
                      class="mat-icon"
                      matTooltip="Enter your old Password"
                    >info_outline
                    </mat-icon
                    >
                  </div>
                </mat-label>
                <mat-form-field
                  appearance="outline"
                  class="width-form-field"
                  floatLabel="never"
                >
                  <input
                    class="form-control"
                    formControlName="old_password"
                    id="old_password"
                    matInput
                    type="password"
                  />
                </mat-form-field>
                @if (f?.old_password.touched && f?.old_password.invalid) {
                  <div
                    class="alert alert-danger"
                  >
                    @if (f?.old_password.errors.required) {
                      <div
                        class="invalid-feedback"
                      >
                        Old Password field is required
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <mat-label>
                  <span class="label-text">New Password</span>
                  <div class="required-info">
                    <span class="required">*</span>
                    <mat-icon [matTooltip]="passwordTooltip"
                              matTooltipHideDelay="300"
                              class="mat-icon"
                    >info_outline
                    </mat-icon
                    >
                  </div>
                </mat-label>
                <mat-form-field
                  appearance="outline"
                  class="width-form-field"
                  floatLabel="never"
                >
                  <input
                    class="form-control"
                    formControlName="password"
                    id="password"
                    matInput
                    type="password"
                  />
                </mat-form-field>
                @if (f?.password.touched && f?.password.invalid) {
                  <div
                    class="alert alert-danger"
                  >
                    @if (f.password.errors?.required) {
                      <div
                        class="invalid-feedback"
                      >
                        Password is required
                      </div>
                    }
                    @if (!f.password.errors?.required && f.password.errors?.minLength) {
                      <div
                        class="invalid-feedback"
                      >
                        {{ f.password.errors.minLength }}
                      </div>
                    }
                    @if (!f.password.errors?.required &&
                    !f.password.errors?.minLength &&
                    f.password.errors?.uppercase) {
                      <div
                        class="invalid-feedback"
                      >
                        {{ f.password.errors.uppercase }}
                      </div>
                    }
                    @if (!f.password.errors?.required &&
                    !f.password.errors?.minLength &&
                    !f.password.errors?.uppercase &&
                    f.password.errors?.symbol) {
                      <div
                        class="invalid-feedback"
                      >
                        {{ f.password.errors.symbol }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <mat-label>
                  <span class="label-text">Confirm Password</span>
                  <div class="required-info">
                    <span class="required">*</span>
                    <mat-icon
                      [matTooltip]="confirmPasswordTooltip"
                      matTooltipHideDelay="300"
                      class="mat-icon"
                    >info_outline
                    </mat-icon
                    >
                  </div>
                </mat-label>
                <mat-form-field
                  appearance="outline"
                  class="width-form-field"
                  floatLabel="never"
                >
                  <input
                    class="form-control"
                    formControlName="password2"
                    id="password2"
                    matInput
                    type="password"
                  />
                </mat-form-field>
                @if (f?.password2.touched && f?.password2.invalid) {
                  <div
                    class="alert alert-danger"
                  >
                    @if (f?.password2?.errors.required) {
                      <div
                        class="invalid-feedback"
                      >
                        Confirm New Password field is required
                      </div>
                    }
                    @if (f?.password2?.errors.confirmedValidator) {
                      <div
                        class="invalid-feedback"
                      >
                        Password Fields are not equal!
                      </div>
                    }
                  </div>
                }
              </div>
            </form>
          </div>
        }

        @if (selectedSection === accountSections.CONNECTED_APPS) {
          <div
            class="connected-apps"
          >
            @if (loadingFlag) {
              <div class="loader">
                <mds-loader></mds-loader>
              </div>
            }
            @for (data of connectedApps; track data; let i = $index) {
              <div
                [class.first]="i === 0"
                class="connected-apps__item"
              >
                <div class="connected-apps__item-info">
                  <div class="title-icon">
                    <img [src]="data.icon" alt="" class="icon" width="20" />
                  </div>
                  <div class="title-name">
                    <span>{{ data.appname }}</span>
                  </div>
                </div>
                @if (data.button === 'connect') {
                  <div>
                    <mds-button
                      (click)="connectHandler(data.appname)"
                      size="medium"
                      type="primary"
                    >Connect
                    </mds-button
                    >
                  </div>
                }
                @if (data.button === 'disconnect') {
                  <div>
                    <mds-button
                      (click)="disconnectHandler(data.appname)"
                      size="medium"
                      type="primary"
                    >Disconnect
                    </mds-button
                    >
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (selectedSection === accountSections.NEWSLETTER_SETTINGS) {
          <div>
            <form class="news-letter" name="subForm">
              <div class="news-letter__header">
                <h2 class="news-letter__header-title">Subscribe to emails</h2>
                <div class="news-letter__header-details">
                  Would you like to subscribe to our newsletter?
                </div>
              </div>
              <mds-checkbox [(ngModel)]="subscription" name="subscription">
                Subscribe to emails ({{ userEmail }})
              </mds-checkbox>
            </form>
          </div>
        }

        @if (selectedSection === accountSections.DELETE_ACCOUNT) {
          <div>
            <section class="news-letter">
              <div class="news-letter__header">
                <h2 class="news-letter__header-title">Delete Account</h2>
                <div class="news-letter__header-details">
                  Would you like to permanently delete your account?
                  <div class="news-letter__header-details-spacer"></div>
                  By proceeding to delete the account you will lose access to the
                  platform and you’ll be required to create a new account to
                  rejoin.
                </div>
              </div>
            </section>
          </div>
        }
      </perfect-scrollbar>
    </div>
  </section>
</app-common-dialog-wrapper>
